(function() {
    'use strict';
    angular
        .module('verificadocumentoApp')
        .factory('TituloRegistrado', TituloRegistrado);

    TituloRegistrado.$inject = ['$resource'];

    function TituloRegistrado ($resource) {
        var resourceUrl =  'public/titulo/:folioControl';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dom = angular.fromJson(data.dom);
                    }
                    return data;
                }
            }
        });
    }
})();